const moment = require('moment');
import {t} from 'l10n';

export function formatAmount(amount, currencySign = true) {
    let currency = 'EUR';
    if (currencySign) {
        currency = '€';
    }

    return amount + ' ' + currency;
}

export function formatHistoryDate(date) {
    let format = t('MM/DD/YYYY [at] HH:mm');
    if (date) {
        return moment(date).format(format);
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/utils/payment.js